import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Card, Tab, Tabs } from "@curves/ui-base";
import { AccountBookProvider, useAccountBookContext } from "./components/AccountBookContext";
import AccountBookOrderOverviewSearchBar from "@icoach/accountBook/AccountBookOrderOverviewSearchBar";
import AccountBookCampaignOrderOverviewSearchBar from "@icoach/accountBook/AccountBookCampaignOrderOverviewSearchBar";
import AccountBookOrderOverviewTable from "@icoach/accountBook/AccountBookOrderOverviewTable";
import { paramsToObject, isEqual } from "@util/utils";
import { initBookmark } from "./staticData";
import { ACCOUNT_BOOK_ORDERS_OVERVIEW_URL } from "@icoach/router/routerPath";
import { ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS } from "@icoach/constants/routerEnums";

/**
 * TAB 組件
 * 使用獨立的 activeTab 狀態管理 TAB 選中狀態（UI 層）
 * 業務邏輯仍使用 orderSourceType（在 AccountBookOrderOverviewSearchBar 中）
 */
const AccountBookOrderOverviewTabs = () => {
	const { activeTab, setActiveTab } = useAccountBookContext();

	const history = useHistory();

	const handleTabChange = (e, value) => {
		history.replace(ACCOUNT_BOOK_ORDERS_OVERVIEW_URL);
		setActiveTab(value);
	};

	return (
		<Box component={"header"} className={"page-header"}>
			<Tabs value={parseInt(activeTab)} onChange={handleTabChange}>
				<Tab className={"py-3"} label={"現場訂單"} value={ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.ON_SITE_ORDER} />
				<Tab className={"py-3"} label={"批次訂單"} value={ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.BATCH_ORDER} />
				<Tab className={"py-3"} label={"抵用券訂單"} value={ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.CAMPAIGN_ORDER} />
			</Tabs>
		</Box>
	);
};
const AccountBookOrderOverviewPage = props => {
	const history = useHistory();
	const search = history.location.search;
	const { pageIndex: pageIndexURL, activeTab: _activeTab = ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.ON_SITE_ORDER } = paramsToObject(search);
	const [activeTab, setActiveTab] = useState(_activeTab); // TAB 選中初始狀態: 現場訂單
	const [bookmark, setBookmark] = useState(initBookmark());
	const [tableData, setTableData] = useState({});
	const refreshRef = useRef(() => {});
	const preloadRef = useRef(true);
	const setBookmarkNum = num => setBookmark(prev => ({ ...prev, pageIndex: num }));
	const isCampaignOrder = isEqual(activeTab, ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.CAMPAIGN_ORDER);

	const childContext = {
		tableData,
		setTableData,
		activeTab,
		setActiveTab,
		bookmark,
		setBookmarkNum,
		refresh: refreshRef,
		setRefresh: el => (refreshRef.current = el),
		dialogRef: props.dialogRef,
	};

	useEffect(
		() => {
			if (!pageIndexURL) return;
			if (preloadRef.current) {
				setBookmarkNum(pageIndexURL);
				preloadRef.current = false;
			}
		},
		// eslint-disable-next-line
		[pageIndexURL],
	);

	// 切換 TAB 時清空表格資料
	useEffect(
		() => {
			setTableData({});
		},
		// eslint-disable-next-line
		[activeTab],
	);

	return (
		<AccountBookProvider value={childContext}>
			<Card className={"tabs-content-layout"}>
				<AccountBookOrderOverviewTabs />
				<Card.CardContent className={"py-3 px-4"}>
					{/* 根據訂單類型條件渲染不同的搜尋欄組件 */}
					{isCampaignOrder ? <AccountBookCampaignOrderOverviewSearchBar className={"mb-2"} /> : <AccountBookOrderOverviewSearchBar className={"mb-2"} />}
					<AccountBookOrderOverviewTable />
				</Card.CardContent>
			</Card>
		</AccountBookProvider>
	);
};

export default AccountBookOrderOverviewPage;
